import React, { Component } from 'react';
import '../styles/channel-info-label.css';

class ChannelInfoLabel extends Component {
    
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="channel-info-label-container">
                <div className="channel-info-label-container-flex">
                    <div ref="channelNumber" className="channel-info-label-container-channelnumber"></div>
                    <div className="channel-info-label-container-image">
                        <img ref="channelImageUrl" className="channel-info-label-image-hide channel-info-label-image" src="" />
                    </div>
                    <div ref="channelEventTitle" className="channel-info-label-container-channeltitle"></div>
                </div>
            </div>
        )
    }
}

export default ChannelInfoLabel;


// WEBPACK FOOTER //
// ./src/playerDomain/components/common/ChannelInfoLabel.js